import { render, staticRenderFns } from "./Overstays.vue?vue&type=template&id=5fd6ff92&scoped=true"
import script from "./Overstays.vue?vue&type=script&lang=js"
export * from "./Overstays.vue?vue&type=script&lang=js"
import style0 from "./Overstays.vue?vue&type=style&index=0&id=5fd6ff92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd6ff92",
  null
  
)

export default component.exports